import TableColumnHeader from './TableColumnHeader';

export default TableColumnHeader;
